import { BrandgenPublicationList } from "../../../types/campaignTypes";

/**
 * Resolve a set's stored list IDs against the lists currently known to the app.
 * Sets store live references, so IDs that no longer resolve (list deleted) are skipped.
 */
export const resolveSetLists = (
  allLists: BrandgenPublicationList[],
  publicationListIds: string[],
): BrandgenPublicationList[] => {
  const byId = new Map(allLists.map((list) => [list.id, list]));
  return publicationListIds.map((id) => byId.get(id)).filter((list): list is BrandgenPublicationList => Boolean(list));
};

export const getActiveDomains = (lists: BrandgenPublicationList[]) =>
  lists.flatMap((list) => list.listDomains?.filter((domain) => domain.active) ?? []);

export const countActiveDomains = (lists: BrandgenPublicationList[]): number => getActiveDomains(lists).length;

/** The selection triplet the campaign builder expects for a picked set. */
export const getSelectionFromLists = (lists: BrandgenPublicationList[]) => {
  const domains = getActiveDomains(lists);
  return {
    listIds: lists.map((list) => list.id),
    domainIds: [...new Set(domains.map((domain) => domain.id))],
    domainNames: [...new Set(domains.map((domain) => domain.name))],
  };
};

export const areSameIdSets = (a: string[], b: string[]): boolean => {
  if (a.length !== b.length) return false;
  const setB = new Set(b);
  return a.every((id) => setB.has(id));
};
